(function(){
    'use strict'

    angular
    .module('app.impuestosRenta')
    .controller('EditarImpuestoRenta', EditarImpuestoRenta);

    EditarImpuestoRenta.$inject = ['$scope', '$animationsSrv', '$routeParams','ImpuestosRentaService', 'logger', '$location'];

    function EditarImpuestoRenta($scope, $animationsSrv, $routeParams, ImpuestosRentaService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];

        vm.impuestoRentaId = $routeParams.id ? $routeParams.id : 0;

        getImpuestoRenta();

        function getImpuestoRenta(){

            if(vm.impuestoRentaId != 0){
                var promise = ImpuestosRentaService.getById(vm.impuestoRentaId);

                promise
                .then(function(impuestoRenta){
                    vm.impuestoRenta = impuestoRenta;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el Impuesto de Renta: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.impuestoRentaForm.$valid){
                if(!vm.impuestoRenta.id){
                    saveImpuestoRenta();
                }
                else if($scope.impuestoRentaForm.$dirty){
                    updateImpuestoRenta();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveImpuestoRenta() {
            var promise = ImpuestosRentaService.save(vm.impuestoRenta);
            
            promise
            .then(function(response){
                logger.success('Impuesto de Renta creado con éxito.');
                clearImpuestoRentaData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el Impuesto de Renta: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateImpuestoRenta(){
            var promise = ImpuestosRentaService.update(vm.impuestoRenta);
            
            promise
            .then(function(response){
                logger.success('Impuesto Renta modificado con éxito.');
                $location.path('/impuestos-renta');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el Impuesto de Renta: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearImpuestoRentaData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.impuestoRenta = {};
            // Set back to pristine.
            $scope.impuestoRentaForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.impuestoRentaForm.$setUntouched();
        };

    }
})();